import React, { useContext, useEffect, useState } from "react";
import { Transition, Dialog } from "@headlessui/react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  API_URL_agentEmail,
  API_URL_ticket,
  API_URL_ticketCollaborator,
} from "constants/api";
import { toast } from "react-toastify";
import axios from "axios";
import { AuthContext } from "context/AuthContext";
import {
  FaPeopleCarry,
  FaTrash,
  FaUserFriends,
  FaUserPlus,
} from "react-icons/fa";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

const ModalReceipt = ({ isOpen, onClose, item, callback }) => {
  const cancelButtonRef = React.useRef(null);

  const { datauser } = useContext(AuthContext);
  const [receipt, setReceipt] = useState([]);

  const handleclose = () => {
    onClose();
    callback();
  };

  const fetchCollaborator = () => {
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "GET",
      params: {
        id_ticket: item, // Parameter URL yang ingin Anda kirimkan
      },
      url: API_URL_ticketCollaborator,
    })
      .then((response) => {
        setReceipt(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteCollaborator = (id) => {
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "DELETE",
      url: API_URL_ticketCollaborator + id + "/",
    })
      .then((response) => {
        fetchCollaborator();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (item) {
      fetchCollaborator();
    }
  }, [isOpen]);

  return (
    <Transition.Root show={isOpen} as={React.Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        initialFocus={cancelButtonRef}
        onClose={() => handleclose()}
      >
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-start justify-center p-4">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-al w-full lg:w-1/2">
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="mt-3 sm:ml-4 sm:mt-0">
                    <div className="flex justify-between">
                      <Dialog.Title
                        as="h3"
                        className="text-2xl font-semibold leading-6 text-gray-900"
                      >
                        List collaborator
                      </Dialog.Title>
                      <button
                        type="button"
                        className=" bg-gray-300 px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-400"
                        onClick={() => handleclose()}
                      >
                        X
                      </button>
                    </div>
                    <div className="mt-3 sm:ml-4 sm:mt-0 max-h-96 overflow-y-auto">
                      {receipt &&
                        receipt.map((item, index) => {
                          return (
                            <div key={index}>
                              <div className="px-6 py-4 bg-gray-200 my-3 flex flex-wrap justify-between items-center">
                                <div className="flex flex-col">
                                  <table>
                                    <tr>
                                      <td className="pr-5">
                                        <p>Username</p>
                                      </td>
                                      <td>:</td>
                                      <td>
                                        <p className="font-semibold">
                                          {item.username}
                                        </p>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="pr-5">
                                        <p>Email</p>
                                      </td>
                                      <td>:</td>
                                      <td>
                                        <p className="font-semibold">
                                          {item.email}
                                        </p>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                                <button
                                  className="px-2 py-2 hover:bg-red-700 bg-red-500 text-white flex items-center rounded-md"
                                  onClick={() => deleteCollaborator(item.id)}
                                >
                                  <FaTrash className="mr-1" /> delete
                                </button>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default ModalReceipt;
